import React from 'react';
import { IMG_URL_RE } from './constants';
import InlineImageText from './InlineImageText';
import { brand } from '../../agentTheme';

export const markdownComponents = {
  p: ({ children }) => {
    const text = typeof children === 'string' ? children : (Array.isArray(children) && children.length === 1 && typeof children[0] === 'string' ? children[0] : null);
    if (text && IMG_URL_RE.test(text.trim())) {
      return <p style={{ margin: '6px 0' }}><InlineImageText text={text.trim()} maxHeight={130} /></p>;
    }
    return <p style={{ margin: '3px 0', lineHeight: 1.65 }}>{children}</p>;
  },
  strong: ({ children }) => <strong style={{ fontWeight: 600, color: 'rgba(255,255,255,0.95)' }}>{children}</strong>,
  ul: ({ children }) => <ul style={{ margin: '6px 0', paddingLeft: 18 }}>{children}</ul>,
  ol: ({ children }) => <ol style={{ margin: '6px 0', paddingLeft: 18 }}>{children}</ol>,
  li: ({ children }) => <li style={{ marginBottom: 3 }}>{children}</li>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer"
      style={{ color: brand.coral, textDecoration: 'underline' }}>
      {children}
    </a>
  ),
  pre: ({ children }) => (
    <pre style={{
      background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 10, padding: '10px 12px', overflowX: 'auto',
      fontSize: 12, margin: '8px 0', fontFamily: 'monospace',
    }}>
      {children}
    </pre>
  ),
  code: ({ children }) => (
    <code style={{
      background: 'rgba(255,255,255,0.1)', borderRadius: 4,
      padding: '1px 5px', fontSize: '0.88em', fontFamily: 'monospace',
    }}>
      {children}
    </code>
  ),
  blockquote: ({ children }) => (
    <blockquote style={{
      borderLeft: `2px solid rgba(255,126,103,0.35)`,
      paddingLeft: 10, margin: '6px 0',
      color: 'rgba(255,255,255,0.5)',
    }}>
      {children}
    </blockquote>
  ),
};
